module.exports = __webpack_public_path__ + "img/Edit.1e57a32d.svg";